import useShoppingCart from "@/hooks/useShoppingCart";
import { IoMdCart } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { trackAddToCart } from "../MetaPixel";

export default function AddToCartButton(props: any) {
  const navigate = useNavigate();
  const { addToCart, productCartQuantity, getLargeApplianceSurcharge } =
    useShoppingCart();

  const {
    openInNewTab,
    is_add_to_cart_available,
    sku,
    currency,
    price,
    markup,
    should_disable,
    image,
    title,
    delivery_days,
    next_delivery_date,
    variants = [],
    larger,
    original_zar_price,
  } = props;

  const handleRedirect = () => {
    if (openInNewTab) {
      window.open(`/products/PLID${sku}`, "_blank", "noopener noreferrer");
    } else {
      navigate(`/products/PLID${sku}`);
    }
  };

  const fbevent = () => {
    trackAddToCart({
      sku: sku,
      currency: currency,
      price: price,
      markup: markup,
      quantity: 1,
      image: image,
      category: title,
      title: title,
    });
  };
  return (
    <div>
      {is_add_to_cart_available ? (
        <div
          onClick={() => {
            fbevent();
            getLargeApplianceSurcharge();

            addToCart({
              sku: sku,
              currency: currency,
              price: price,
              markup: markup,
              quantity: 1,
              image: image,
              title: title,
              delivery_days: delivery_days,
              next_delivery_date: next_delivery_date,
              variants: variants,
              original_zar_price,
            });
          }}
          className={`border flex justify-center ${
            larger ? "text-[16px] sm:text-lg" : "text-[10px] sm:text-sm"
          } items-center gap-4 cursor-pointer text-white bg-[#000] border-[#000] border-solid text-center ${
            larger ? "p-3" : "p-2 sm:p-2.5"
          }  rounded sm:rounded-md hover:bg-red-500 hover:border-red-500 hover:text-white  select-none`}
        >
          {productCartQuantity(sku, variants) > 0 && (
            <span
              className={`rounded-sm px-2 gap-2  flex justify-center items-center ${
                larger
                  ? "text-[14px] sm:text-[14px]"
                  : "text-[10px] sm:text-[12px]"
              } bg-white text-black`}
            >
              <IoMdCart
                size={larger ? 18 : 15}
                color="black"
                className="hidden lg:block"
              />
              {productCartQuantity(sku, variants)}
            </span>
          )}
          {productCartQuantity(sku, variants) > 0
            ? "Added to Cart"
            : "Add to Cart"}
        </div>
      ) : (
        <div
          onClick={() => (!should_disable ? handleRedirect() : null)}
          className={`border ${
            should_disable
              ? "disabled"
              : "cursor-pointer hover:bg-black hover:text-white"
          } bg-[#F9F9F9] border-[#E2E2E2] border-solid ${
            larger ? "text-[16px] sm:text-lg" : "text-[10px] sm:text-sm"
          } sm:text-sm text-center ${
            larger ? "p-3" : "p-2 sm:p-2.5"
          } rounded-md sm:rounded-md`}
        >
          Shop All Options
        </div>
      )}
    </div>
  );
}
